module.exports = __webpack_public_path__ + "static/media/New Giks logo.5d6b67e2.png";